import React, { useState, useEffect } from 'react';
import { addGraphSection } from '../../../FeatureRedux/GraphData/addGraphSection';
import { getallGraphdata } from '../../../FeatureRedux/GraphData/showGraphdata';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { X } from 'lucide-react';
import { Graphupdate } from '../../../FeatureRedux/GraphData/updateGraphSection';

function AddSectorGraph({ handleCloseModal, editData, isEditMode, onUpdate }) {
  const [sector, setSector] = useState('');
  const [cost, setCost] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isEditMode && editData) {
      setSector(editData.sector);
      setCost(editData.cost.toString());
    } else {
      setSector('');
      setCost('');
    }
  }, [editData, isEditMode]);

  const handleSubmit = async () => {
    if (!sector.trim() || !cost || isNaN(cost)) {
      toast.error('Please fill in all fields with valid values', {
        position: 'top-center',
        autoClose: 3000,
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = { 
        sector: sector.trim(),
        cost: parseFloat(cost)
      };
      
      if (isEditMode && editData) {
        await onUpdate(editData._id, payload);
      } else {
        await dispatch(addGraphSection(payload));
        toast.success('Sector added successfully!', {
          position: 'top-center',
          autoClose: 4000,
        });
      }
      
      dispatch(getallGraphdata());
      handleCloseModal();
    } catch (error) {
      const action = isEditMode ? 'update' : 'add';
      toast.error(error.message || `Failed to ${action} sector. Please try again.`, {
        position: 'top-center',
        autoClose: 4000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  return (
    <>
      <ToastContainer />
      <div
        className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50"
        onClick={handleBackdropClick}
      >
        <div className="bg-white p-8 rounded-xl shadow-2xl w-96 relative">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">
              {isEditMode ? 'Edit Sector Data' : 'Add Sector Data'}
            </h2>
            <button
              onClick={handleCloseModal}
              className="text-gray-500 hover:text-gray-700 transition"
            >
              <X size={24} />
            </button>
          </div>

          <div className="space-y-6">
            <div>
              <label htmlFor="sector" className="block mb-1 text-gray-700 font-medium">
                Sector
              </label>
              <input
                type="text"
                id="sector"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                value={sector}
                onChange={(e) => setSector(e.target.value)}
                placeholder="Enter sector name"
              />
            </div>

            <div>
              <label htmlFor="cost" className="block mb-1 text-gray-700 font-medium">
                Cost (in billions)
              </label>
              <input
                type="number"
                id="cost"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                value={cost}
                onChange={(e) => setCost(e.target.value)}
                placeholder="Enter cost"
              />
            </div>
          </div>

          <div className="flex justify-center mt-8">
            <button
              className={`px-8 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 transition font-medium shadow-md hover:shadow-lg ${
                isSubmitting ? 'opacity-75 cursor-not-allowed' : ''
              }`}
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  {isEditMode ? 'Updating...' : 'Processing...'}
                </>
              ) : (
                isEditMode ? 'Update' : 'Submit'
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddSectorGraph;

// import React, { useState, useEffect } from 'react';
// import { addGraphSection } from '../../../FeatureRedux/GraphData/addGraphSection';
// import { getallGraphdata } from '../../../FeatureRedux/GraphData/showGraphdata';
// import { useDispatch } from 'react-redux';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { X } from 'lucide-react';
// import axios from 'axios';
// import axiosInstance from '../../axiosInstance';
// import { Graphupdate } from '../../../FeatureRedux/GraphData/updateGraphSection';

// function AddSectorGraph({ handleCloseModal, editData, isEditMode }) {
//   const [sector, setSector] = useState('');
//   const [cost, setCost] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (isEditMode && editData) {
//       setSector(editData.sector);
//       setCost(editData.cost.toString()); // Convert to string for input
//     } else {
//       setSector('');
//       setCost('');
//     }
//   }, [editData, isEditMode]);

//   const handleSubmit = async () => {
//     // Check if sector is empty string and cost is empty or NaN
//     if (!sector.trim() || !cost || isNaN(cost)) {
//       toast.error('Please fill in all fields with valid values', {
//         position: 'top-center',
//         autoClose: 3000,
//       });
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const payload = { 
//         sector: sector.trim(),
//         cost: parseFloat(cost) // Convert to number before sending
//       };
      
//       if (isEditMode && editData) {
//         await axiosInstance.put(`/graph/updateGraphData/${editData._id}`);
//         await dispatch(Graphupdate(payload));
//         toast.success('Sector updated successfully!', {
//           position: 'top-center',
//           autoClose: 4000,
//         });
//       } else {
//         await dispatch(addGraphSection(payload));
//         toast.success('Sector added successfully!', {
//           position: 'top-center',
//           autoClose: 4000,
//         });
//       }
      
//       dispatch(getallGraphdata());
//       handleCloseModal();
//     } catch (error) {
//       const action = isEditMode ? 'update' : 'add';
//       toast.error(`Failed to ${action} sector. Please try again.`, {
//         position: 'top-center',
//         autoClose: 4000,
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleBackdropClick = (e) => {
//     if (e.target === e.currentTarget) {
//       handleCloseModal();
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <div
//         className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50"
//         onClick={handleBackdropClick}
//       >
//         <div className="bg-white p-8 rounded-xl shadow-2xl w-96 relative">
//           <div className="flex justify-between items-center mb-6">
//             <h2 className="text-2xl font-bold text-gray-800">
//               {isEditMode ? 'Edit Sector Data' : 'Add Sector Data'}
//             </h2>
//             <button
//               onClick={handleCloseModal}
//               className="text-gray-500 hover:text-gray-700 transition"
//             >
//               <X size={24} />
//             </button>
//           </div>

//           <div className="space-y-6">
//             <div>
//               <label htmlFor="sector" className="block mb-1 text-gray-700 font-medium">
//                 Sector
//               </label>
//               <input
//                 type="text"
//                 id="sector"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
//                 value={sector}
//                 onChange={(e) => setSector(e.target.value)}
//                 placeholder="Enter sector name"
//               />
//             </div>

//             <div>
//               <label htmlFor="cost" className="block mb-1 text-gray-700 font-medium">
//                 Cost (in billions)
//               </label>
//               <input
//                 type="number"
//                 id="cost"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
//                 value={cost}
//                 onChange={(e) => setCost(e.target.value)}
//                 placeholder="Enter cost"
//               />
//             </div>
//           </div>

//           <div className="flex justify-center mt-8">
//             <button
//               className={`px-8 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 transition font-medium shadow-md hover:shadow-lg ${
//                 isSubmitting ? 'opacity-75 cursor-not-allowed' : ''
//               }`}
//               onClick={handleSubmit}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? (
//                 <>
//                   <svg
//                     className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   {isEditMode ? 'Updating...' : 'Processing...'}
//                 </>
//               ) : (
//                 isEditMode ? 'Update' : 'Submit'
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AddSectorGraph;                                                                                                                                                                                                       
// import React, { useState } from 'react';
// import { addGraphSection } from '../../../FeatureRedux/GraphData/addGraphSection';
// import { getallGraphdata } from '../../../FeatureRedux/GraphData/showGraphdata';
// import { useDispatch } from 'react-redux';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// function AddSectorGraph({ handleCloseModal }) {
//   const [sector, setSector] = useState('');
//   const [cost, setCost] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const dispatch = useDispatch();

//   const handleSubmit = async () => {
//     if (!sector.trim() || !cost.trim()) {
//       toast.error('Please fill in all fields', {
//         position: 'top-center',
//         autoClose: 3000,
//       });
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const payload = { sector, cost };
//       await dispatch(addGraphSection(payload));
//       dispatch(getallGraphdata());

//       toast.success('Sector added successfully!', {
//         position: 'top-center',
//         autoClose: 4000,
//       });

//       handleCloseModal();
//     } catch (error) {
//       toast.error('Failed to add sector. Please try again.', {
//         position: 'top-center',
//         autoClose: 4000,
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleBackdropClick = (e) => {
//     if (e.target === e.currentTarget) {
//       handleCloseModal();
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <div
//         className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50"
//         onClick={handleBackdropClick}
//       >
//         <div className="bg-white p-8 rounded-xl shadow-2xl w-96 relative">
//           <div className="flex justify-between items-center mb-6">
//             <h2 className="text-2xl font-bold text-gray-800">Add Sector Data</h2>
//             <button
//               onClick={handleCloseModal}
//               className="text-gray-500 hover:text-gray-700 transition"
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="h-6 w-6"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//               >
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>

//           <div className="space-y-6">
//             {/* Sector Input */}
//             <div>
//               <label htmlFor="sector" className="block mb-1 text-gray-700 font-medium">
//                 Sector
//               </label>
//               <input
//                 type="text"
//                 id="sector"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
//                 value={sector}
//                 onChange={(e) => setSector(e.target.value)}
//                 placeholder="Enter sector name"
//               />
//             </div>

//             {/* Cost Input */}
//             <div>
//               <label htmlFor="cost" className="block mb-1 text-gray-700 font-medium">
//                 Cost (in billions)
//               </label>
//               <input
//                 type="number"
//                 id="cost"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
//                 value={cost}
//                 onChange={(e) => setCost(e.target.value)}
//                 placeholder="Enter cost"
//               />
//             </div>
//           </div>

//           <div className="flex justify-center mt-8">
//             <button
//               className={`px-8 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 transition font-medium shadow-md hover:shadow-lg ${
//                 isSubmitting ? 'opacity-75 cursor-not-allowed' : ''
//               }`}
//               onClick={handleSubmit}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? (
//                 <>
//                   <svg
//                     className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   Processing...
//                 </>
//               ) : (
//                 'Submit'
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AddSectorGraph;


// import React, { useState } from 'react';
// import { addGraphSection } from '../../../FeatureRedux/GraphData/addGraphSection';
// import { getallGraphdata } from '../../../FeatureRedux/GraphData/showGraphdata';
// import { useDispatch } from 'react-redux';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// function AddSectorGraph({ handleCloseModal }) {
//   const [sector, setSector] = useState('');
//   const [cost, setCost] = useState('');
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const dispatch = useDispatch();

//   const handleSubmit = async () => {
//     if (!sector.trim() || !cost.trim()) {
//       toast.error('Please fill in all fields', {
//         position: "top-center",
//         autoClose: 3000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const payload = { sector, cost };
//       await dispatch(addGraphSection(payload));
//       dispatch(getallGraphdata());
      
//       toast.success('Sector added successfully!', {
//         position: "top-center",
//         autoClose: 4000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
      
//       handleCloseModal();
//     } catch (error) {
//       toast.error('Failed to add sector. Please try again.', {
//         position: "top-center",
//         autoClose: 4000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleBackdropClick = (e) => {
//     if (e.target === e.currentTarget) {
//       handleCloseModal();
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <div 
//         className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm transition-all duration-300 z-50"
//         onClick={handleBackdropClick}
//       >
//         <div className="bg-white p-8 rounded-xl shadow-2xl w-96">
//           <div className="flex justify-between items-center mb-6">
//             <h2 className="text-2xl font-bold text-gray-800">Add Sector Data</h2>
//             <button 
//               onClick={handleCloseModal}
//               className="text-gray-500 hover:text-gray-700 transition-colors duration-200"
//             >
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>
          
//           <div className="space-y-6">
//             <div className="relative">
//               <input
//                 type="text"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 peer"
//                 value={sector}
//                 onChange={(e) => setSector(e.target.value)}
//                 placeholder=" "
//               />
//               <label className="absolute left-4 top-3 text-gray-500 pointer-events-none transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-3 peer-focus:-top-2 peer-focus:text-sm peer-focus:text-blue-600 bg-white px-1 -top-2 text-sm">
//                 Sector
//               </label>
//             </div>
            
//             <div className="relative">
//               <input
//                 type="number"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 peer"
//                 value={cost}
//                 onChange={(e) => setCost(e.target.value)}
//                 placeholder=" "
//               />
//               <label className="absolute left-4 top-3 text-gray-500 pointer-events-none transition-all duration-200 peer-placeholder-shown:text-base peer-placeholder-shown:top-3 peer-focus:-top-2 peer-focus:text-sm peer-focus:text-blue-600 bg-white px-1 -top-2 text-sm">
//                 Cost (in billions)
//               </label>
//             </div>
//           </div>
          
//           <div className="flex justify-center mt-8">
//             <button 
//               className={`px-8 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-blue-500 text-white hover:from-blue-700 hover:to-blue-600 transition-all duration-200 font-medium shadow-md hover:shadow-lg ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`}
//               onClick={handleSubmit}
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? (
//                 <>
//                   <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                   </svg>
//                   Processing...
//                 </>
//               ) : 'Submit'}
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AddSectorGraph;


// import React, { useState } from 'react';
// import { addGraphSection } from '../../../FeatureRedux/GraphData/addGraphSection';
// import { getallGraphdata } from '../../../FeatureRedux/GraphData/showGraphdata';

// import { useDispatch } from 'react-redux';
// function AddSectorGraph({ handleCloseModal }) {
//   const [sector, setSector] = useState('');
//   const [cost, setCost] = useState('');

//   const dispatch = useDispatch();

//   const handleSubmit = async () => {

//     console.log('Sector:', sector);
//     console.log('Cost (in billions):', cost);
//     const payload = {sector , cost };
//     await dispatch(addGraphSection(payload))
//     dispatch(getallGraphdata())
//     handleCloseModal();
//   };

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white p-6 rounded-lg shadow-lg w-96">
//         <h2 className="text-xl font-bold mb-4">Add Sector Data</h2>
//         <label className="block mb-2">
//           Sector:
//           <input
//             type="text"
//             className="w-full p-2 border rounded mt-1"
//             value={sector}
//             onChange={(e) => setSector(e.target.value)}
//           />
//         </label>
//         <label className="block mb-4">
//           Cost (in billions):
//           <input
//             type="number"
//             className="w-full p-2 border rounded mt-1"
//             value={cost}
//             onChange={(e) => setCost(e.target.value)}
//           />
//         </label>
//         <div className="flex justify-end gap-2">
//           <button className="px-4 py-2 bg-gray-300 rounded" onClick={handleCloseModal}>Cancel</button>
//           <button className="px-4 py-2 bg-blue-600 text-white rounded" onClick={handleSubmit}>Submit</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AddSectorGraph;


